import React, { useState } from "react";
import IconWithRoundedBorder from "../borderCir/BoderCir";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign,faMoneyBill,faWallet } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { adpaypeee, msgPromtsuccess,loaderActionSlice } from "../../features/userSlice";
const AddFUnAuto = () => {
  
const {Info}=useSelector((state)=>state.users);
const [money,setMoney]=useState('');
const [isdisabled,setisdisabled]=useState(false);

const dispatch=useDispatch();
const handlePayment = async() => {
  if (parseInt(money)<parseInt(Info?.MIN_DEPOSIT)) {
         dispatch(msgPromtsuccess({msg:`Minimum deposit limit is ${Info?.MIN_DEPOSIT} .`,error:true}));
         return;
       }
   setisdisabled(true);
   // const payeeAddress = Info?.UPI_ADMIN;
   // const payeeName = Info?.UPI_NAME || '';
   // const amount = money; // Replace with dynamic value
   // const currency = "INR";
   const transactionId = `TXN${Date.now()}`; // Generate unique transaction ID
   // const transactionNote = `Payment for Order${transactionId}`;
   // const redirectUrl = `https://matkafun.us/payment-status?transaction_id=${transactionId}`;

   var form_data_new = new FormData();

   form_data_new.append('USER_ID',Info?.phone_number);
   form_data_new.append('TRANS_ID',transactionId);
   form_data_new.append('AMOUNT',money);

  
   // const upiUrl = encodeURI(`upi://pay?pa=${payeeAddress}&pn=${payeeName}&am=${amount}&cu=${currency}&tn=${transactionNote}&url=${redirectUrl}`);

   // console.log(upiUrl);

     // Redirect to UPI apps
     try{
       dispatch(loaderActionSlice(true));
     const data = await dispatch(adpaypeee(form_data_new)).unwrap(); // Unwrap to get the resolved value
             if(data?.status && data?.status!='FAILURE'){
                     window.location.href = data.result.payment_url;
              }else if(data?.status==='FAILURE'){
               msgAccessPromt({dispatch,error:true,msg:data?.msg});
              }
     }catch(error){
       msgAccessPromt({dispatch,error:true,msg:'Somthing Wents Wrong please try again!!!'});
     }
     dispatch(loaderActionSlice(false));
   setisdisabled(false);
 };

return (
        <div className="all_bids" style={{padding:'4%'}}>
            <div className="imageAdd" style={{textAlign:'center'}}>
            <img src='home/images/add_money.png' style={{maxWidth:'49%'}}/>
            </div>
            <div>
                <div className="child_comp" style={{height:'78px',borderRadius:'9px',boxShadow:'#e0e0e0 5px 5px 5px'}}><IconWithRoundedBorder boxColor={'#BDBDBD'} innerColor={'white'} outerColor={'white'} FonCompo={<FontAwesomeIcon icon={faWallet} color="rgb(243, 75, 78)" size='2x'/>}/>
                <div style={{display:'inline-block',marginTop:'3%',marginLeft:'9%'}}>
                    <h3 style={{color:'rgb(243, 75, 78)'}}><FontAwesomeIcon icon={faIndianRupeeSign} size='1x' color='rgb(243, 75, 78)'/> {(Info.wallet!=0)?Info.wallet+'.00':Info.wallet}</h3>
                    <p style={{color:'gray'}}>Total Wallet Balance</p>
                </div>
                </div>
            </div><br/>
            <h4 style={{textAlign:'left',padding:'14px'}}>Add Fund</h4>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faMoneyBill} color="gray" size="1x" padding='3%' /></i>
                <input className="input_lable_deep" type="number" value={money} onChange={(e)=>setMoney(e.target.value)} placeholder="Enter Points" />
            </div><br/><br/><br/>
            <button style={{marginLeft:'9%',width:'80%'}} disabled={isdisabled} onClick={handlePayment} className="continue-button">Pay</button>
            <br/><br/><br/>
        </div>
    );
};

export default AddFUnAuto;
